import { getInitials } from "../utils";

export const Avatar = ({
  firstName,
  lastName,
  size = "md",
  className,
  customBgColor = null,
  customTextColor = null,
  onClick,
}) => {
  // const getInitials = (fullName) => {
  //   if (!fullName || fullName.trim() === "") return "?";

  //   const names = fullName.trim().split(" ");
  //   if (names.length === 1) {
  //     // Single name - take first character
  //     return names[0].charAt(0).toUpperCase();
  //   } else {
  //     // Multiple names - take first character of first and last name
  //     return (
  //       names[0].charAt(0) + names[names.length - 1].charAt(0)
  //     ).toUpperCase();
  //   }
  // };

  const name = `${firstName} ${lastName}`;

  const getRandomColor = (name) => {
    const colors = [
      "#EF4444",
      "#3B82F6",
      "#10B981",
      "#F59E0B",
      "#8B5CF6",
      "#EC4899",
      "#6366F1",
      "#F97316",
      "#14B8A6",
      "#06B6D4",
      "#059669",
      "#F43F5E",
    ];

    // Use name to generate consistent color (same name = same color)
    let hash = 0;
    for (let i = 0; i < (name || "").length; i++) {
      hash = (name || "").charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
  };

  const getSizeClasses = (size) => {
    const sizes = {
      sm: "w-10 h-10 text-sm",
      md: "w-12 h-12 text-base",
      lg: "w-16 h-16 text-lg",
      xl: "w-24 h-24 text-2xl",
      xxl: "w-32 h-32 text-2xl",
    };
    return sizes[size] || sizes.md;
  };

  const bgColor = customBgColor || getRandomColor(name);
  const textColor = customTextColor || "#fff";
  const initials = getInitials(firstName, lastName);
  const sizeClasses = getSizeClasses(size);

  return (
    <div
      onClick={onClick}
      className={`flex items-center justify-center  text-[${textColor}] font-semibold rounded-full ${sizeClasses} ${className}`}
      style={{
        backgroundColor: bgColor,
      }}
    >
      {initials}
    </div>
  );
};
